import app from "@/common/plugins/vueInstance";
import vueMixpanel from "vue-mixpanel";

app.use(vueMixpanel, {
  token: process.env.VUE_APP_MIXPANEL_TOKEN!,
  config: {
    debug: process.env.NODE_ENV === "production" ? false : true,
    ignore_dnt: true,
    track_pageview: "full-url",
  },
});
